import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Seo, breadcrumbLd } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { get } from "@/lib/api";

export default function States() {
  const { data: states = [] } = useQuery({ queryKey: ["states"], queryFn: () => get("/states") });
  const crumbs = [{ name: "Home", to: "/" }, { name: "States", to: "/states" }];
  return (
    <div data-testid="states-page">
      <Seo title="Browse HOAs by State" description="Browse homeowners associations in every U.S. state. See HOA counts, cities and average fees." path="/states" jsonLd={breadcrumbLd(crumbs)} />
      <PageHeader eyebrow="Directory" title="Browse HOAs by state" subtitle="Choose a state to see cities, communities and average monthly HOA fees.">
        <Breadcrumbs items={crumbs} />
      </PageHeader>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {states.map((s) => (
          <Link key={s.slug} to={`/${s.slug}`} data-testid={`state-link-${s.slug}`}
            className="flex items-center justify-between rounded-2xl border border-[#E2E8F0] bg-white p-5 hover:border-[#03A896] hover:shadow-md transition-[box-shadow,border-color]">
            <div>
              <p className="font-semibold text-[#0B2150]">{s.state}</p>
              <p className="text-xs text-slate-600">{s.count} HOAs · {s.city_count} cities{s.avg_fee != null && ` · avg $${s.avg_fee}/mo`}</p>
            </div>
            <span className="font-display text-2xl font-bold text-[#63D8C4]">{s.code}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
